import { render, staticRenderFns } from "./ServiceTypeView.vue?vue&type=template&id=10c3976d&scoped=true"
import script from "./ServiceTypeView.vue?vue&type=script&lang=js"
export * from "./ServiceTypeView.vue?vue&type=script&lang=js"
import style0 from "./ServiceTypeView.vue?vue&type=style&index=0&id=10c3976d&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c3976d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10c3976d')) {
      api.createRecord('10c3976d', component.options)
    } else {
      api.reload('10c3976d', component.options)
    }
    module.hot.accept("./ServiceTypeView.vue?vue&type=template&id=10c3976d&scoped=true", function () {
      api.rerender('10c3976d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/billingHistory/components/ServiceTypeView.vue"
export default component.exports